// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awPageGrey } from 'Utils/themes';

// The toolbar stays fixed over the dashboard; the content below starts under it and the
// projects controls pin to its bottom edge while the list scrolls.
export const PAGE_TOOLBAR_HEIGHT_PX = 90;

// AUT-6432: the toolbar is the search row - a search pill and the Projects / Map switch.
// Sorting, filtering and the list/cards switch belong to ProjectsSubheader.
const styles = (theme: any, showMapView?: boolean) => ({
  pageToolbar: {
    ...(!showMapView && { position: 'fixed',
      height: `${PAGE_TOOLBAR_HEIGHT_PX}px`,
      width: '100vw',
      zIndex: '10' }),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(4),
    // On a phone the search row lines up with the content column instead of keeping the desktop's wide margins
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    // The page's ground, so the fixed toolbar and the list scrolling under it read as one surface.
    backgroundColor: awPageGrey,
  },
  // Matches the content column below it: the design's width, but never wider than the
  // viewport it sits in.
  pageToolbarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '19px',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  // Takes the row; the Projects / Map switch keeps its own width beside it.
  searchField: {
    flex: 1,
    minWidth: 0,
  },
});

export default styles;
